import {MenuItemActionBase} from "../menu-item-action-base";
import {IServiceFactoryExtended} from "../../service-factory-extended.interface";
import {IMenuItemConfigReader} from "../../menu-items-common/menu-item-config-reader/menu-item-config-reader.interface";
import {AreaType, ControlCenterOpenSource} from "@sparkware/uc-sdk-core";
import {CHANNEL_ELEMENTS, CHANNEL_SOURCE} from "../../../../common/const/casinofied-analytics-consts";

export default class ControlCenterAction extends MenuItemActionBase {
    constructor(configReader: IMenuItemConfigReader, services: IServiceFactoryExtended) {
        super("controlCenterMenuItem", configReader, services);
    }

    protected async _onClick(): Promise<void> {
        await this.services.appLauncher.openControlCenterFull({
            businessCorrelationID: this.services.tools.getGuid(),
            channel: {
                area: AreaType.UserArea,
                element: CHANNEL_ELEMENTS.controlCenterUsefulLink,
                source: CHANNEL_SOURCE.casinoClient
            },
            appSpecificParameters: {
                source: ControlCenterOpenSource.UserArea
            }
        });
    }
}